import {forwardRef, ReactNode} from 'react';
import {cn} from '../lib/utils';
import {Button, ButtonProps} from './button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from './dropdown-menu';
import {Icons} from '../icons';
import {Slot} from '@radix-ui/react-slot';

export interface DropdownButtonProps {
  children: ReactNode;
  className?: string;
  variant?: ButtonProps['variant'];
  size?: ButtonProps['size'];
  dropdownMenuMarkup: ReactNode;
}

export const DropdownButton = forwardRef<HTMLDivElement, DropdownButtonProps>(
  (
    {
      children,
      className,
      dropdownMenuMarkup,
      variant = 'default',
      size = 'default',
    }: DropdownButtonProps,
    ref,
  ) => {
    const iconSize = size === 'sm' ? 'icon-sm' : 'icon';

    return (
      <div
        ref={ref}
        className={cn('inline-flex shrink-0 items-center', className)}
      >
        <Slot className="rounded-r-none">{children}</Slot>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              variant={variant}
              size={iconSize}
              className="-ml-px rounded-l-none border-l border-l-primary-foreground/20 px-2 shadow-none"
            >
              <Icons.chevronDown className="w-4 h-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            {dropdownMenuMarkup}
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    );
  },
);
DropdownButton.displayName = 'DropdownButton';
